import {
    REQUEST,
    SUCCESS,
    ERROR,
} from 'state/actions/locale'


const initialState = {
    loaded: false,
    loading: false,
    messages: {},
    errorMessage: '',
    language: '',
}

export default function locale(state = initialState, action = {}) {
    switch (action.type) {
    case REQUEST:
        return {
            ...state,
            loading: true,
            errorMessage: '',
        }
    case SUCCESS:
        return {
            ...state,
            loading: false,
            loaded: true,
            messages: action.payload.messages,
            language: action.payload.language,
        }
    case ERROR:
        return {
            ...state,
            loading: false,
            errorMessage: action.payload.errorMessage,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/locale.js